import { DEFAULT_METRICS } from 'seller/pages/advertising/analytics/constants';
import {
  SET_CAMPAIGN_KEYWORD_SELECTIONS,
  SET_CHART_DECAY_THRESHOLD,
  SET_CHART_WINDOW_SIZE,
  SET_IS_PARENT_VIEW,
  SET_SELECTED_METRICS,
  SET_SELECTED_SECONDARY_METRICS,
  SET_SELECTED_THIRD_METRICS
} from '../saga/advertising';

const initialState = {
  chartWindowSize: 30,
  chartDecayThreshold: 10,
  selectedMetrics: DEFAULT_METRICS.primary,
  selectedSecondaryMetrics: DEFAULT_METRICS.secondary,
  selectedThirdMetrics: DEFAULT_METRICS.tertiary,
  // campaignId -> { primary:[], secondary:[], tertiary:[] }
  campaignKeywordSelections: {},
  isParentView: true
};

export const advertisingSettingsSelector = state => state.advertisingSettingsV2;

const advertisingSettings = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_CHART_WINDOW_SIZE: {
      return { ...state, chartWindowSize: payload };
    }
    case SET_CHART_DECAY_THRESHOLD: {
      return { ...state, chartDecayThreshold: payload };
    }
    case SET_SELECTED_METRICS: {
      return { ...state, selectedMetrics: payload };
    }
    case SET_SELECTED_SECONDARY_METRICS: {
      return { ...state, selectedSecondaryMetrics: payload };
    }
    case SET_SELECTED_THIRD_METRICS: {
      return { ...state, selectedThirdMetrics: payload };
    }
    case SET_CAMPAIGN_KEYWORD_SELECTIONS: {
      return { ...state, campaignKeywordSelections: payload };
    }
    case SET_IS_PARENT_VIEW: {
      return { ...state, isParentView: payload };
    }
    default: {
      return state;
    }
  }
};

export default advertisingSettings;
